import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './Services.css';
import { Helmet } from 'react-helmet';

const Facilities = () => {
  const facilities = [
    {
      title: 'International-Standard Indoor Badminton Courts',
      description: 'Our academy features professionally designed indoor badminton courts with high-quality wooden flooring that meets international standards. These courts provide excellent grip, shock absorption, and playing comfort, helping players perform at their best while reducing injury risk.',
      image: '/img/International-Standard Indoor Badminton Courts.jpg'
    },
    {
      title: 'Advanced Lighting System',
      description: 'We provide uniform, glare-free LED lighting across all courts, ensuring clear visibility during training and matches. Proper lighting helps players track the shuttle accurately and enhances overall playing experience, especially during high-speed rallies.',
      image: '/img/Advanced Training.jpg'
    },
    {
      title: 'High-Quality Playing Surface & Safety Flooring',
      description: 'The playing surface is designed to minimize strain on joints and muscles. Our safety flooring supports long training sessions and intense drills, ensuring comfort, balance, and injury prevention for players of all age groups.',
      image: '/img/High-Quality Playing Surface & Safety Flooring.jpg'
    },
    {
      title: 'Dedicated Fitness & Conditioning Area',
      description: 'Our academy includes a well-equipped fitness zone for strength training, endurance building, agility drills, and flexibility exercises. This facility helps players improve stamina, speed, and overall physical performance essential for competitive badminton.',
      image: '/img/Dedicated Fitness & Conditioning Area.jpg'
    },
    {
      title: 'Modern Training Equipment',
      description: 'Imperial Badminton Academy provides advanced training equipment such as shuttle feeding machines, agility ladders, cones, resistance tools, and fitness accessories. These tools help enhance technical skills, reflexes, and match readiness.',
      image: '/img/Modern Training Equipment.jpg'
    },
    {
      title: 'Comfortable Changing Rooms',
      description: 'We offer clean, hygienic, and well-maintained changing rooms for players. These spaces are designed for convenience and comfort, allowing athletes to prepare for training sessions and recover afterward in a relaxed environment.',
      image: '/img/Comfortable Changing Rooms.jpg'
    },
    {
      title: 'Player Rest & Recovery Area',
      description: 'A dedicated rest area is available for players to relax between sessions. This space supports recovery, hydration, and mental relaxation, helping players maintain energy and focus throughout training.',
      image: '/img/Player Rest & Recovery Area.jpg'
    },
    {
      title: 'Safe & Secure Training Environment',
      description: 'Player safety is our top priority. The academy maintains strict safety standards, proper supervision, and secure access to ensure a safe and disciplined environment for all trainees, especially young players.',
      image: '/img/Safe & Secure Training Environment.jpg'
    },
  ];

  const courtRental = [
    { type: 'Peak Hours (6PM - 10PM)', weekday: '₹800/hour', weekend: '₹1000/hour' },
    { type: 'Off-Peak Hours', weekday: '₹500/hour', weekend: '₹700/hour' },
    { type: 'Early Morning (6AM - 8AM)', weekday: '₹400/hour', weekend: '₹500/hour' },
    { type: 'Monthly Package (20 hours)', weekday: '₹8,000', weekend: '₹12,000' },
  ];

  return (
    <>
      <Helmet>
        <title>Facilities</title>
      </Helmet>
      <div className="facilities-page">
        <div className="page-header">
          <div className="container">
            <h1>Our Facilities</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <Link to="/services">Services</Link>
              <span>/</span>
              <span>Facilities</span>
            </div>
          </div>
        </div>

        <section className="facilities-intro section">
          <div className="container">
            <div className="section-title">
              <h2>State-of-the-Art Facilities</h2>
              <p>
                Our academy features world-class infrastructure designed to provide the best
                training environment for badminton players at all levels.
              </p>
            </div>
          </div>
        </section>

        <section className="facilities-list section bg-light">
          <div className="container">
            <div className="facilities-grid">
              {facilities.map((facility, index) => (
                <div key={index} className="facility-card">
                  <div className="facility-image">
                    <img src={facility.image} alt={facility.title} />
                  </div>
                  <div className="facility-content">
                    <h3>{facility.title}</h3>
                    <p>{facility.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="court-rental section">
          <div className="container">
            <div className="section-title">
              <h2>Court Rental Rates</h2>
              <p>
                Book our international standard courts for practice sessions,
                friendly matches, or private coaching.
              </p>
            </div>
            <div className="schedule-table" style={{ maxWidth: '800px', margin: '0 auto' }}>
              <table>
                <thead>
                  <tr>
                    <th>Slot Type</th>
                    <th>Weekday Rate</th>
                    <th>Weekend Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {courtRental.map((item, index) => (
                    <tr key={index}>
                      <td><strong>{item.type}</strong></td>
                      <td>{item.weekday}</td>
                      <td>{item.weekend}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p style={{ textAlign: 'center', marginTop: '20px', color: 'var(--text-light)' }}>
              * Equipment rental available at additional cost. Advance booking recommended.
            </p>
          </div>
        </section>

        <section className="services-cta section">
          <div className="container">
            <div className="cta-box">
              <h2>Want to See Our Facilities in Person?</h2>
              <p>
                Schedule a tour of our academy and experience our world-class
                facilities firsthand.
              </p>
              <div className="cta-buttons">
                <Link to="/contact" className="btn btn-accent">
                  Book a Tour <FaArrowRight />
                </Link>
                <a href="tel:+919876543210" className="btn btn-secondary">
                  Call: +91 98765 43210
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Facilities;
